import React, { HTMLAttributes } from "react";
import * as palette from "@govlaunch/palette";
import { ITag } from "~/types/types";
import Tooltip from "~/components/Tooltip";

export default function Award({
  award,
  ...props
}: { award: Pick<ITag, "_id" | "name"> } & HTMLAttributes<HTMLSpanElement>) {
  return (
    <Tooltip
      backgroundColor={palette.mediumBlue}
      boxStyle={{
        borderRadius: 13.5,
        boxShadow: "0 2px 5px 0px rgba(0, 0, 0, 0.5)",
      }}
      render={() => {
        return (
          <div
            css={{
              padding: 8,
              color: palette.text,
              fontSize: 14,
            }}
          >
            {award.name}
          </div>
        );
      }}
    >
      {({ innerRef, bind }) => {
        return (
          <span
            ref={innerRef}
            css={{
              padding: "5px 10px",
              marginTop: 8,
              marginRight: 8,
              backgroundColor: palette.mediumBlue,
              borderRadius: 13.5,
              fontSize: 14,
              color: palette.text,
              lineClamp: 1,
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              maxWidth: "45%",
            }}
            {...bind}
            {...props}
          >
            {award.name}
          </span>
        );
      }}
    </Tooltip>
  );
}
